import { useSelector } from 'react-redux';
import {
    getAssignedToMeFilter,
    getFilters,
    getSelectedTicketAvailableStatuses,
    getSelectedTicketId,
    getSelectedTicketStatus,
    getSelectedWorkflow,
    getTicket,
    getTicketAsReport,
    getTicketHistoryAsSourceSet,
    getTicketHistoryStatus,
    getTicketsMode,
    getTicketsPaneVisible,
    getTicketsSourceSetModel,
    getTicketsStatus,
    getWorkflows,
    getWorkflowsStatuses,
} from './index';

export const useTicketsStatus = () => useSelector(getTicketsStatus);
export const useTicketDetailsStatus = () =>
    useSelector(getSelectedTicketStatus);

export const useSelectedTicketId = () => useSelector(getSelectedTicketId);
export const useTicketsPaneVisible = () => useSelector(getTicketsPaneVisible);
export const useTicketsMode = () => useSelector(getTicketsMode);

export const useTicket = () => useSelector(getTicket);
export const useTicketHistory = () => useSelector(getTicketHistoryAsSourceSet);
export const useTicketHistoryStatus = () => useSelector(getTicketHistoryStatus);
export const useTicketHistorySourceSetModel = () =>
    useSelector(getTicketsSourceSetModel);

export const useTicketAsReport = () => useSelector(getTicketAsReport);
export const useTicketsSourceSetModel = () =>
    useSelector(getTicketsSourceSetModel);
export const useWorkflowStatuses = () => useSelector(getWorkflowsStatuses);
export const useSelectedTicketAvailableStatuses = () =>
    useSelector(getSelectedTicketAvailableStatuses);
export const useSelectedWorkflow = () => useSelector(getSelectedWorkflow);
export const useWorkflows = () => useSelector(getWorkflows);
export const useFilters = () => useSelector(getFilters);
export const useAssignedToMeFilter = () => useSelector(getAssignedToMeFilter);
